import { erpAxios } from '..';

const stepsUnlocked = async (brojZahtjeva) => {
  const { data } = await erpAxios(`/loanApplication/stepsUnlocked/${brojZahtjeva}`);
  return data;
};

export default stepsUnlocked;
